import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { storeLanguagePreference, SUPPORTED_LANGS } from '../utils/languageStorage';

interface LanguageWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that syncs URL language parameter with i18next
 * and updates the document language attribute
 */
function LanguageWrapper({ children }: LanguageWrapperProps) {
  const { i18n } = useTranslation();
  const { lang } = useParams();

  useEffect(() => {
    if (lang && SUPPORTED_LANGS.includes(lang) && i18n.language !== lang) {
      // Change i18next language
      i18n.changeLanguage(lang);
      
      // Update document language attribute for accessibility and SEO
      document.documentElement.lang = lang;
      
      // Store the language preference (not marked as manual since this is URL-driven)
      storeLanguagePreference(lang, false);
    }
  }, [lang, i18n]);

  return <>{children}</>;
}

export default LanguageWrapper;